import gql from "graphql-tag";

export const templateFragment = gql`
  fragment TemplateFragment on Template {
    id
    name
    rank
  }
`;
